import { FormControl, InputLabel, Select, MenuItem } from '@mui/material'
import React from 'react'
import {
  Control,
  Controller,
  FieldValues,
  UseControllerProps
} from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { PercentTypeList } from '../../../api/models/percentTypeList.model'
import { SignedList } from '../../../api/models/signedList.model'

export interface SetRateTypeSelectorsProps<T extends FieldValues> {
  signedList: SignedList[]
  percentTypeList: PercentTypeList[]
  control: Control<T>
  signedController: Omit<UseControllerProps<T>, 'control'>
  percentTypeController: Omit<UseControllerProps<T>, 'control'>
}

const SetRateTypeSelectors = <T extends FieldValues>({
  signedList,
  percentTypeList,
  percentTypeController,
  signedController,
  control
}: SetRateTypeSelectorsProps<T>) => {
  const { t } = useTranslation()
  return (
    <>
      <Controller
        control={control}
        rules={{
          required: {
            value: true,
            message: t('validations.required')
          },
          shouldUnregister: true
        }}
        shouldUnregister
        {...signedController}
        render={({ field: { onChange, ...field }, fieldState: { error } }) => (
          <FormControl
            sx={{
              position: 'relative',
              width: '100px'
            }}
            error={!!error}
            size='small'
          >
            <InputLabel id='signed'>+/-</InputLabel>
            <Select
              size='small'
              sx={{
                width: '100px'
              }}
              labelId='signed'
              label='+/-'
              onChange={(e) => {
                const val = e.target.value as any
                onChange(val)
              }}
              {...field}
            >
              {signedList.map((sign) => (
                <MenuItem key={sign.id} value={sign.id}>
                  {sign.value}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
      />
      <Controller
        control={control}
        rules={{
          required: {
            value: true,
            message: t('validations.required')
          },
          shouldUnregister: true
        }}
        shouldUnregister
        {...percentTypeController}
        render={({ field: { onChange, ...field }, fieldState: { error } }) => (
          <FormControl
            sx={{
              width: '200px'
            }}
            error={!!error}
            size='small'
          >
            <InputLabel id='percentType'>
              {t('apps.rates.rateDataGrid.modal.quantity')}/
              {t('apps.rates.rateDataGrid.modal.percentage')}
            </InputLabel>
            <Select
              size='small'
              sx={{
                width: '200px'
              }}
              label={`${t('apps.rates.rateDataGrid.modal.quantity')}/${t(
                'apps.rates.rateDataGrid.modal.percentage'
              )}`}
              onChange={(e) => {
                onChange(e.target.value as any)
              }}
              {...field}
            >
              {percentTypeList.map((percentType) => (
                <MenuItem key={percentType.id} value={percentType.id}>
                  {percentType.value}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
      />
    </>
  )
}
export default SetRateTypeSelectors
